import { useState } from 'react';

export function useLessonMeta({ initialBannerImage }) {
  const [lessonTitle, setLessonTitle] = useState('');
  const [bannerImage, setBannerImage] = useState(initialBannerImage);
  const [docBanners, setDocBanners] = useState({});
  const [homeworkBanners, setHomeworkBanners] = useState({});
  const [editorContents, setEditorContents] = useState({});
  const [whiteboardContents, setWhiteboardContents] = useState({});

  return {
    lessonTitle, setLessonTitle,
    bannerImage, setBannerImage,
    docBanners, setDocBanners,
    homeworkBanners, setHomeworkBanners,
    editorContents, setEditorContents,
    whiteboardContents, setWhiteboardContents,
  };
}
